// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class SurveyStartSessionResponseModel {
    static getAttributeTypeMap() {
        return SurveyStartSessionResponseModel.attributeTypeMap;
    }
}
SurveyStartSessionResponseModel.discriminator = undefined;
SurveyStartSessionResponseModel.additionalProperties = false;
SurveyStartSessionResponseModel.attributeTypeMap = [
    {
        "name": "surveySessionId",
        "baseName": "surveySessionId",
        "type": "number"
    },
    {
        "name": "firstQuestionId",
        "baseName": "firstQuestionId",
        "type": "number"
    },
];
//# sourceMappingURL=surveyStartSessionResponseModel.js.map